// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {ReactNode, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';
import www_util from 'hola_pub_util';
import {Spacer} from '../homepage/spacer';
import styles from './doc.module.less';

interface i_doc_props {
    children: ReactNode;
    cls?: string;
}
export const Doc = (props: i_doc_props)=>{
    const {children, cls} = props;
    const {theme} = useContext(Settings_context);
    const {i18n} = useTranslation();
    return <div className={cn(theme.root, styles.doc, cls)}
      dir={www_util.lng_dir(i18n.language)}>
      <div className={theme.container}>
        <div className={styles.content}>
          {children}
        </div>
      </div>
      <Spacer/>
      <Spacer/>
    </div>;
};
